import { render, staticRenderFns } from "./SimpleOrganizationChartComponent.vue?vue&type=template&id=22a8ea62&scoped=true"
var script = {}
import style0 from "./SimpleOrganizationChartComponent.vue?vue&type=style&index=0&id=22a8ea62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8ea62",
  null
  
)

export default component.exports